/*
 * @Author: liujunhong
 * @Date: 2023/2/21
 * @Desc: 页面内嵌验证码
 */

import React, { FC } from 'react';
import { Captcha as CaptchaDom } from 'gyyx-component-lib';
import { Captcha, ChangeData } from 'gyyx-component-lib/es/interface/captcha';
import styles from './style.less';

interface Props extends Omit<Captcha, 'onChange'> {
  reset?: never,
  onChange?: (val: boolean) => void
}

const Index: FC<Props> = props => {
  const {bId, onChange, ...reset} = props;
  return <div id="form_item_captcha" className={styles.captcha_wrap}>
    <CaptchaDom {...reset} visible closable={false} bId={bId} mask={false} confirmable={false}
                getContainer={'#form_item_captcha'}
                onChange={(data: ChangeData) => onChange?.(data.completed)}
    />
  </div>;
};
export default Index;
